module.exports = __webpack_public_path__ + "img/@logo_maiim@3x.e834d469.png";